import "./Home.css";
import Events from "./components/events/Events";
import Footer from "../../components/footer/Footer";
import Journey from "./components/journey/Journey";
import Landing from "./components/landing/Landing";
import Navbar from "../../components/navbar/Navbar";
import News from "../home/components/news/News";
import RequestInformation from "../home/components/requestinformation/RequestInformation";
import Stats from "../home/components/stats/Stats";
import Testimonies from "../home/components/testimonies/Testimonies";
import Tour from "../home/components/tour/Tour";
import Welcome from "../home/components/welcome/Welcome";

const Home = () => {
	return (
		<div className='home'>
			<Navbar />
			<div className='content-wrapper'>
				<Landing />
				<RequestInformation />
				<Testimonies />
				<News />
				<Events />
				<Journey />
				<Stats />
				<Welcome />
				<Tour />
				<Footer />
			</div>
		</div>
	);
};

export default Home;
